import React from 'react';

export const RowContext = React.createContext();
RowContext.displayName = 'ContentfulRowContext';
